module.exports = __webpack_public_path__ + "static/media/4.58d24366.jpg";